module.exports = __webpack_public_path__ + "static/image/history/pc/202302.ver2_0_2.jpg?3ce246e1";